import { pbxLocationsEn } from './en'

export const pbxLocationsEnUs = pbxLocationsEn
